module.exports = __webpack_public_path__ + "static/media/cf.54152082.svg";